// extracted by mini-css-extract-plugin
export default {"heading":"DefaultBid_heading__YqOfz","wrapper":"DefaultBid_wrapper__K0MjH","suggestionText":"DefaultBid_suggestionText__4H1V0","pandaImg":"DefaultBid_pandaImg__yJZkO"};